"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { action, observable, computed } from "mobx";
export var FolderAnimationStates = /* @__PURE__ */ ((FolderAnimationStates2) => {
  FolderAnimationStates2["Visible"] = "visible";
  FolderAnimationStates2["Hidden"] = "hidden";
  return FolderAnimationStates2;
})(FolderAnimationStates || {});
export class FolderTreeViewStore {
  constructor(getFoldersFunc, selectionStateProvider) {
    this.getFoldersFunc = getFoldersFunc;
    this.selectionStateProvider = selectionStateProvider;
    this._treeState = /* @__PURE__ */ new Map();
  }
  get folders() {
    return this.getFoldersFunc();
  }
  isFolderToggledOpen(id) {
    const folderState = this._treeState.get(id);
    if (!!folderState) {
      return folderState.isToggledOpen;
    } else {
      return false;
    }
  }
  isFolderSelected(id) {
    return id === this.selectedFolder;
  }
  onToggle(folderId) {
    const folderState = this.getOrCreateViewState(folderId);
    folderState.isToggledOpen = !folderState.isToggledOpen;
  }
  get selectedFolder() {
    return this.selectionStateProvider.selectedFolder;
  }
  getOrCreateViewState(folderId) {
    if (!this._treeState.has(folderId)) {
      this._treeState.set(folderId, {
        isToggledOpen: false
      });
    }
    return this._treeState.get(folderId);
  }
}
__decorateClass([
  observable
], FolderTreeViewStore.prototype, "_treeState", 2);
__decorateClass([
  action
], FolderTreeViewStore.prototype, "onToggle", 1);
__decorateClass([
  computed
], FolderTreeViewStore.prototype, "selectedFolder", 1);
__decorateClass([
  action
], FolderTreeViewStore.prototype, "getOrCreateViewState", 1);
